import React from 'react';
import { ROUTES } from 'consts';
import {
  Route
} from 'react-router-dom';
import {
  ProjectList,
  ProjectCreate,
  ProjectEdit,
  UserList,
  UserCreate,
  UserEdit,
  CompanyList,
  CompanyEdit,
  CompanyCreate,
  ConfigurationEdit,
  RoleList,
  RoleCreate,
  RoleEdit,
  InventoryList,
  InventoryCreate,
  InventoryEdit,
  CredentialEdit,
  CredentialCreate,
  CredentialList,

  CredentialListOLD,
  CredentialCreateOLD,
  CredentialEditOLD,
  InventoryListOLD,
  InventoryCreateOLD,
  InventoryEditOLD,
  MacroExecute,
  ApiTokenList
} from 'views';

const oldVersionApi = JSON.parse(process.env.REACT_APP_OLD_VERSION_API || false) || false;


const privateRoutes = [
  //TODO: DELETE THIS PLEASE >:l
  <Route
    exact
    path={ROUTES.INVENTORY_LIST}
    key={ROUTES.INVENTORY_LIST}
    render={(props) => oldVersionApi ? <InventoryListOLD {...props} /> : <InventoryList {...props} />}
  />,
  <Route
    exact
    path={ROUTES.INVENTORY_CREATE}
    key={ROUTES.INVENTORY_CREATE}
    render={(props) => oldVersionApi ? <InventoryCreateOLD {...props} /> : <InventoryCreate {...props} />}
  />,
  <Route
    exact
    path={oldVersionApi ? `${ROUTES.INVENTORY_EDIT}/:inventoryId/:baseUrl` : `${ROUTES.INVENTORY_EDIT}/:inventory`}
    key={`${ROUTES.INVENTORY_EDIT}/:inventory`}
    render={(props) => oldVersionApi ? <InventoryEditOLD {...props} /> : <InventoryEdit {...props} />}
  />,
  <Route
    exact
    path={ROUTES.CREDENTIAL_LIST}
    key={ROUTES.CREDENTIAL_LIST}
    render={(props) => oldVersionApi ? <CredentialListOLD {...props} /> : <CredentialList {...props} /> }
  />,
  <Route
    exact
    path={`${ROUTES.CREDENTIAL_EDIT}/:credentialId`}
    key={`${ROUTES.CREDENTIAL_EDIT}/:credentialId`}
    render={(props) => oldVersionApi ? <CredentialEditOLD {...props} /> : <CredentialEdit {...props} />}
  />,
  <Route
    exact
    path={`${ROUTES.CREDENTIAL_VIEW}/:credentialId`}
    key={`${ROUTES.CREDENTIAL_VIEW}/:credentialId`}
    render={(props) => oldVersionApi ? <CredentialEditOLD {...props} /> : <CredentialEdit {...props } />}
  />,
  <Route
    exact
    path={ROUTES.CREDENTIAL_CREATE}
    key={ROUTES.CREDENTIAL_CREATE}
    render={(props) => oldVersionApi ? <CredentialCreateOLD {...props} /> : <CredentialCreate {...props} />}
  />,
  <Route
    exact
    path={ROUTES.PROJECT_LIST}
    key={ROUTES.PROJECT_LIST}
    render={(props) => <ProjectList {...props} />}
  />,
  <Route
    exact
    path={ROUTES.PROJECT_CREATE}
    key={ROUTES.PROJECT_CREATE}
    render={(props) => <ProjectCreate {...props} />}
  />,
  <Route
    exact
    path={`${ROUTES.PROJECT_EDIT}/:projectId`}
    key={`${ROUTES.PROJECT_EDIT}/:projectId`}
    render={(props) => <ProjectEdit {...props} />}
  />,
  <Route
    exact
    path={ROUTES.COMPANY_LIST}
    key={ROUTES.COMPANY_LIST}
    render={(props) => <CompanyList {...props} />}
  />,
  <Route
    exact
    path={ROUTES.COMPANY_CREATE}
    key={ROUTES.COMPANY_CREATE}
    render={(props) => <CompanyCreate {...props} />}
  />,
  <Route
    exact
    path={`${ROUTES.COMPANY_EDIT}/:companyId`}
    key={`${ROUTES.COMPANY_EDIT}/:companyId`}
    render={(props) => <CompanyEdit {...props} />}
  />,
  <Route
    exact
    path={ROUTES.USER_LIST}
    key={ROUTES.USER_LIST}
    render={(props) => <UserList {...props} />}
  />,
  <Route
    exact
    path={ROUTES.USER_CREATE}
    key={ROUTES.USER_CREATE}
    render={(props) => <UserCreate {...props} />}
  />,
  <Route
    exact
    path={`${ROUTES.USER_EDIT}/:username`}
    key={`${ROUTES.USER_EDIT}/:username`}
    render={(props) => <UserEdit {...props} />}
  />,
  <Route
    exact
    path={ROUTES.CONFIGURATION}
    key={ROUTES.CONFIGURATION}
    render={(props) => <ConfigurationEdit {...props} />}
  />,
  <Route
    exact
    path={ROUTES.MACRO_EXECUTE}
    key={ROUTES.MACRO_EXECUTE}
    render={(props) => <MacroExecute {...props} />}
  />,
  <Route
    exact
    path={ROUTES.ROLE_LIST}
    key={ROUTES.ROLE_LIST}
    render={(props) => <RoleList {...props} />}
  />,
  <Route
    exact
    path={ROUTES.ROLE_CREATE}
    key={ROUTES.ROLE_CREATE}
    render={(props) => <RoleCreate {...props} />}
  />,
  <Route
    exact
    path={`${ROUTES.ROLE_EDIT}/:roleId`}
    key={`${ROUTES.ROLE_EDIT}/:roleId`}
    render={(props) => <RoleEdit {...props} />}
  />,
  <Route
    exact
    path={ROUTES.API_TOKEN_LIST}
    key={ROUTES.API_TOKEN_LIST}
    render={(props) => <ApiTokenList {...props} />}
  />
];

export default privateRoutes;
